import { CallEmsApi, iEmsApiResponseBody } from "./TenantAPI";

export interface GetMisModelsResponse {
    items: MisModel[];
}

export interface MisModel {
    id: number;
    name: string;
}

export async function GetMisModels(tenantToken: string): Promise<iEmsApiResponseBody<GetMisModelsResponse>> {
    return await CallEmsApi<GetMisModelsResponse>(tenantToken, "GET", `MIS/MISModels/`);
}
